<template>
  <div class="surverys-tab-survey-card card" :class="{ hoverable: !disabled }" :ref="dataSurvey.key" data-step="2">
    <div class="card-content">
      <div class="card-image waves-effect" @click="$_goTo()">
        <img :src="dataSurvey.thumbnail" alt="" :style="{
          filter: disabled ? 'grayscale(1)' : ''
        }" />
      </div>
      <div class="card-title center" @click="$_goTo()">
        {{ dataSurvey.title }}
      </div>

    </div>
    <div class="progress-wrapper">
      <div class="progress-pusher">
        <div class="description center">
          <!-- {{ dataSurvey.description }} -->
          {{ progressBar }} Completed
        </div>
        <!--  -->

        <div class="c-progress-bar-wrapper">
          <div class="c-progress-percent">
            {{ onlyProgressX ? `${onlyProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div class="c-progress" :style="{ width: `${onlyProgressX}%` }"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="action-wrapper">
      <div class="card-action">
        <button class="btn-flat btn-floating waves-effect" :disabled="disabled || shouldFetch" @click="$_goTo()">
          <i class="material-icons-outlined indigo-text text-accent-4">edit</i>
        </button>
        <button @click="$_deleteCurrentSurvey(dataSurvey)" class="btn-flat btn-floating c-btn btn-delete waves-effect"
          :disabled="disabled || shouldFetch">
          <i class="material-icons-outlined grey-text text-darken-3">delete</i>
        </button>
        <button class="btn-flat btn-floating c-btn btn-continue waves-effect" :disabled="disabled || shouldFetch"
          @click="$_goTo()">
          <i class="material-icons-outlined grey-text text-darken-3">play_arrow</i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { deleteSurvey, getSurvey, updateSurvey } from "@/api/survey.api";

const isElementInView = (elChild, elParent) => {
  const elChildRect = elChild.getBoundingClientRect();
  const isInView =
    elChildRect.left >= 0 && elChildRect.right <= elParent.clientWidth;

  return isInView;
};

export default {
  name: "surveyCardEnergy",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    dataSurvey: {
      type: Object,
      default: () => ({}),
    },
    dataPerformViewCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      parentEl: null,
    };
  },
  mounted() {
    this.parentEl = document.getElementById("home-survey-tabs");
    this.$_isElementInView();
    // this.$_getSurvey();
  },
  isInViewPort() { },
  watch: {
    dataPerformViewCheck() {
      this.$_isElementInView();
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.User.user,
      // energyX: (state) => state.User.user.energy,
      windHazard: (state) => state.Surveys.windHazard,
      floodHazard: (state) => state.Surveys.floodHazard,
      waterHazard: (state) => state.Surveys.waterHazard,
      shouldFetch: (state) => state.Surveys.shouldFetch,
    }),
    energyX() {
      if (!this.user) return false
      return this.user.energy
    },
    energy: {
      get() {
        return this.energyX && this.energyX !== '' ? JSON.parse(this.energyX) : false
      }
    },
    windHazardProgressX() {
      if (this.windHazard) {
        const len = Object.values(this.windHazard.survey).length;

        const currentLen = Object.values(this.windHazard.survey).filter(
          (item) => {
            if (typeof item === "object") {
              if (item.length > 0) {
                return item;
              }
            } else {
              return item;
            }
          }
        ).length;

        return Math.round((currentLen / len) * 100);
      }
      return 0;
    },
    floodHazardProgressX() {
      if (this.floodHazard) {
        const len = Object.values(this.floodHazard.survey).length;

        const currentLen = Object.values(this.floodHazard.survey).filter(
          (item) => {
            if (typeof item === "object") {
              if (item.length > 0) {
                return item;
              }
            } else {
              return item;
            }
          }
        ).length;

        return Math.round((currentLen / len) * 100);
      }

      return 0;
    },
    assessmentProgressX: {
      get() {
        const allArr = [
          { ...this.floodHazard },
          { ...this.windHazard },
          { ...this.waterHazard },
        ];
        const k =
          allArr.map((x) => x.assessment).filter((y) => y && y.content).length *
          (100 / allArr.length).toFixed(0);
        return k > 99 ? 100 : k;
      },
    },
    onlyProgressX() {
      let elec =
        this.energy &&
          this.energy.electricity.annual_total &&
          this.energy.electricity.annual_total !== ""
          ? 50
          : 0;
      let gas =
        this.energy &&
          this.energy.gas.annual_total &&
          this.energy.gas.annual_total !== ""
          ? 50
          : 0;
      return `${elec + gas}`;
    },
    progressBar: {
      get() {
        let elec =
          this.energy &&
            this.energy.electricity.annual_total &&
            this.energy.electricity.annual_total !== ""
            ? 50
            : 0;
        let gas =
          this.energy &&
            this.energy.gas.annual_total &&
            this.energy.gas.annual_total !== ""
            ? 50
            : 0;
        return `${elec + gas}%`;
      },
    },
  },
  methods: {
    ...mapActions({
      updateWindSurvey: "Surveys/UPDATE_WIND_HAZARD",
      setWindSurveyStarted: "Surveys/SET_WIND_HAZARD_STARTED",
      updateWaterSurvey: "Surveys/UPDATE_WATER_HAZARD",
      setWaterSurveyStarted: "Surveys/SET_WATER_HAZARD_STARTED",
      updateFloodSurvey: "Surveys/UPDATE_FLOOD_HAZARD",
      setFloodSurveyStarted: "Surveys/SET_FLOOD_HAZARD_STARTED",
      setShowTour: "Surveys/SET_SHOW_SURVEY_TOUR",
    }),
    $_getSurvey() {
      if (this.shouldFetch) {
        getSurvey(this.user.id, this.dataSurvey.tag)
          .then((res) => {
            const data = res.data[0];
            // Store survey data
            if (data) {
              this.setShowTour(false);
              const survey = JSON.parse(data.acf.survey_data);
              survey.id = data.id;
              if (this.dataSurvey.key === "wind_hazard") {
                this.updateWindSurvey(survey);
                this.setWindSurveyStarted(true);
              } else if (this.dataSurvey.key === "flood_hazard") {
                this.updateFloodSurvey(survey);
                this.setFloodSurveyStarted(true);
              } else {
                this.updateWaterSurvey(survey);
                this.setWaterSurveyStarted(true);
              }
            }
            this.$emit("updateFetch", this.dataSurvey.tag);
          })
          .catch((err) => {
            this.$emit("updateFetch", this.dataSurvey.tag);
          });
      }
    },
    $_isElementInView() {
      const inView = isElementInView(
        this.$refs[this.dataSurvey.key],
        this.parentEl
      );

      this.$emit("updateElView", {
        key: this.dataSurvey.key,
        isInView: inView,
      });
    },
    $_deleteCurrentSurvey(e) {
      let data = {
        title: `Clear ${e.title} data`,
        message: `Area you sure you want to clear all data associated with ${e.title}`,
        //hasImage: '/img/banner-image@2x.cd301ba7.png',
        buttons: [
          {
            id: 0,
            value: "DISMISS",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },

          {
            id: 1,
            value: "CLEAR DATA",
            action: () => {
              let id =
                e.route === "WindHazard"
                  ? this["windHazard"].id
                  : e.route === "FloodHazard"
                    ? this["floodHazard"].id
                    : e.route === "WaterHazard"
                      ? this["waterHazard"].id
                      : "";
              this.$store.commit("Surveys/DELETE_SURVEY_DATA", {
                item:
                  e.route === "WindHazard"
                    ? "windHazard"
                    : e.route === "FloodHazard"
                      ? "floodHazard"
                      : e.route === "WaterHazard"
                        ? "waterHazard"
                        : "",
              });

              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },
        ],
        dataType: "",
      };
      this.$store.commit("TRIGGER_DIALOG", { data: data });
    },
    $_goTo() {
      if (this.shouldFetch) return;
      this.$router.push({ name: "energyCalculator" });
    },
    $_saveDataToCould(id) {
      if (id) {
        if (id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this.windHazard),
            },
          };
          updateSurvey(id, payload)
            .then((res) => { })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.surverys-tab-survey-card {
  /*   flex-shrink: 0;
  border-radius: 5px;
  width: 200px;
  padding: 1rem;
  margin-right: 25px; */
  /*
  .image-wrapper {
    width: 100%;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  } */

  /*   .title {
    text-transform: uppercase;
    color: #545454;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  } */
  &.card {
    height: calc(100% - 1.5rem);
    border-radius: 10px;

    //overflow: hidden;
    .card-image {
      height: 140px;

      @media screen and (min-width: 1024px) {
        height: 140px;
      }

      width: 100%;
      text-align: center;

      img {
        height: 100%;
        width: auto;
        display: inline-block;
      }
    }

    .card-content {
      padding: 16px 16px;

      .card-title {
        font-size: 15.5px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 0px;
        cursor: pointer;
        text-transform: uppercase;
        /* 			white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis; */
      }
    }

    .action-wrapper {
      height: 56px;
      width: 100%;

      .card-action {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    .card-action {
      padding: 0px 16px 16px 16px;
      border-radius: 0px 0px 5px 5px;
      display: flex;
      justify-content: space-between;

      button {
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .description {
    font-size: 12px;
  }

  .c-progress-bar-wrapper {
    margin-top: 8px;

    .c-progress-percent {
      font-size: 9px;
      color: #9c9c9c;
    }

    .c-progress-bar {
      position: relative;
      border-radius: 5px;
      width: 100%;
      height: 9px;
      background: #e4e4e4;
      overflow: hidden;
    }

    .c-progress {
      background: #5374f8;
      height: 100%;
    }
  }
}

.progress-wrapper {
  padding: 0 16px 16px;
  height: 64px;

  .progress-pusher {
    position: absolute;
    width: calc(100% - 32px);
    bottom: 72px;
  }
}

.btn-flat[disabled] {
  background-color: #DFDFDF !important;
}
</style>
